import React from "react";
import { CiFolderOn } from "react-icons/ci";
import { VscGithubAlt } from "react-icons/vsc";
import { CiShare1 } from "react-icons/ci";

const ProjectCard = ({ project }) => {
  return (
    <div className="project">
      <div>
        <div className="icons">
          <div>
            <CiFolderOn size={40} fill="#64ffda" />
          </div>
          <div className="d-flex gap-3 align-items-center">
            <a href={project.github_link} target="_blank">
              <VscGithubAlt size={22} />
            </a>
            <a href={project.live_page} target="_blank">
              <CiShare1 size={24} />
            </a>
          </div>
        </div>
        <h3 className="project-title">
          <a href={project.live_page} target="_blank">
            {project.title}
          </a>
        </h3>
        <p className="project-description">{project.description}</p>
      </div>
      <ul className="project-tech-list">
        {project.technologies?.map((tech, index) => (
          <li key={index}>{tech}</li>
        ))}
      </ul>
    </div>
  );
};

export default ProjectCard;
